import { render, staticRenderFns } from "./Brand_project.vue?vue&type=template&id=2f0c5756&scoped=true&"
import script from "./Brand_project.vue?vue&type=script&lang=js&"
export * from "./Brand_project.vue?vue&type=script&lang=js&"
import style0 from "./Brand_project.vue?vue&type=style&index=0&id=2f0c5756&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0c5756",
  null
  
)

export default component.exports